import Typography from "../../reusable/Typography/Typography"
import {ChevronRight} from "react-bootstrap-icons"
import Image from "next/image"
import ReusableConsultation from "../../bikeDetails/ResusableConsultation"
import WhatsAppButton from "../../navigation/WhatsAppButton"
import MobileModal from "../../reusable/MobileModal"
import React, {useContext, useState} from "react"
import {ModalContext} from "../../../context/ModalContext"
import {useTranslation} from "next-i18next"
function MoreWaysToFindEbikeQuizCta({isBlack = false}:{isBlack?:boolean}) {
	const {setModalContent, openDrawer} = useContext(ModalContext)

	const openSideBar = () => {
		setModalContent(<div
			className="col-12 px-3 px-4 py-4">
			<Typography variant="bodySmBlack"
				className="mb-2 "
				style={{fontSize: "28px", lineHeight: "36px", maxWidth: "320px"}}
				semanticTag="p">{t("need-help-to-make-choice?")}</Typography>
			<Typography className={`mb-4 ${isBlack ? "text-black" : "text-secondary"}`}
				variant="bodySmBold"
				style={{fontSize: "14px", lineHeight: "20px"}}>{t("modal-consult-title-2")}</Typography>
			<ReusableConsultation isBookAppointment
				className="cursor-pointer mb-2" />
			<WhatsAppButton withTextAndArrow/>
		</div>)
		openDrawer()
	}

	const {t} = useTranslation()
	const [isModalOpen, setIsModalOpen] = useState(false)
	return (
		<>
			<div onClick={() => openSideBar()}
				className="col-12 cursor-pointer d-none d-md-flex align-items-center justify-content-center gap-2">
				<Typography variant="bodySmBold"
					className={`${isBlack ? "text-black" : "text-secondary"}`}
					style={{fontSize: "14px", lineHeight: "20px"}}
					semanticTag="span">{t("need-help-to-make-choice?")} </Typography>
				<ChevronRight size={18} />
			</div>

			<div onClick={() => setIsModalOpen(true)}
				className="d-flex d-md-none gap-3 container cursor-pointer  align-items-center ">

				<div className="d-flex align-items-center justify-content-center position-relative"
					style={{
						minWidth: 40,
						minHeight: 40,
						borderRadius: "4px",
						zIndex: 2,
						backgroundColor: "#F8F8F8"
					}}>
					<Image src={"/assets/icons/usp-return.svg"}
						height={ 20}
						width={ 20}
						objectFit="contain" />
				</div>

				<div className="gap-2 d-flex  align-items-center justify-content-start">
					<Typography variant="bodySmBold"
						semanticTag="span">{t("need-help-to-make-choice?")} </Typography>
					<ChevronRight size={18} />
				</div>
			</div>
			<MobileModal handleClose={() => setIsModalOpen(false)}
				modalOpen={isModalOpen} >
				<div
					className="col-12 px-3 px-4 py-4">
					<Typography variant="bodySmBlack"
						className="mb-2 "
						style={{fontSize: "28px", lineHeight: "36px", maxWidth: "320px"}}
						semanticTag="p">{t("need-help-to-make-choice?")}</Typography>
					<Typography className={`mb-4 ${isBlack ? "text-black" : "text-secondary"}`}
						variant="bodySmBold"
						style={{fontSize: "14px", lineHeight: "20px"}}>{t("modal-consult-title-2")}</Typography>
					<ReusableConsultation isBookAppointment
						className="cursor-pointer mb-2" />
					<WhatsAppButton withTextAndArrow/>
				</div>
			</MobileModal>
		</>
	)
}

export default MoreWaysToFindEbikeQuizCta
